module.exports = __webpack_public_path__ + "static/img/ML03.32e6c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML03.jpg
// module id = g0eq
// module chunks = 9